import { NoInfer } from "@store/Framework/Types/Common";

const mapManyItems = <T extends Toolkit.GoogleAnalytics.Item | Toolkit.GoogleAnalytics.MapperModel>(
    items: T[],
    mapper: (item: NoInfer<T>, ...args: any[]) => Toolkit.GoogleAnalytics.AnyItem = (x: any) => x,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const startIndex = options?.startIndex ?? 0;

    return items.map((x, index) => ({
        index: startIndex + index,
        ...mapper(x, options),
    }));
};

export default mapManyItems;
